/**
 * Which bundle is this? Stamped by Vite at build time (see `define` in
 * vite.config.ts) so it travels with the JavaScript rather than the deploy —
 * an installed PWA serving yesterday's cached bundle reports yesterday.
 */
declare const __BUILD_VERSION__: string;
declare const __BUILD_COMMIT__: string;
declare const __BUILD_AT__: string;

export const BUILD = {
  version: __BUILD_VERSION__,
  /** Short commit SHA, suffixed `+` when built from a dirty tree. */
  commit: __BUILD_COMMIT__,
  builtAt: __BUILD_AT__,
} as const;

/** `0.1.0 · a1b2c3d` — the one-line form for a status row. */
export const BUILD_LABEL = `${BUILD.version} · ${BUILD.commit}`;

export function buildDate(): string {
  const d = new Date(BUILD.builtAt);
  return Number.isNaN(d.getTime()) ? BUILD.builtAt : d.toLocaleString();
}
